module.exports = __webpack_public_path__ + "img/server.91caae68.jpg";